import React, { Component, Fragment } from 'react'
import { withRouteData, Head } from 'react-static'

import { SITE_CONSTANTS } from '../../../utils/constants'

import Cookies from 'js-cookie'
import Template from '../../site/landing-pages/TemplateLandingPage'
import TwoCols from '../../../blocks/LandingPageBlocks/TwoCols'
import SliderTestimonialCardStars from './../../../components/site/TestimonialCardStars/SliderTestimonialCardStars'
//import NewMenu from '../../blocks/Menu/NewMenu'
import HeroPartners from '../../../blocks/Hero/HeroPartners'
import CenteredTitleSection from '../../../blocks/LandingPageBlocks/CenteredTitleSection'

import './NewPartnerv2.scss'
import NewOurResults from '.././../../blocks/NewOurResults/NewOurResultsv2';
import CardTrialNew from '../../../blocks/CardFooter/CardTrialv2'
import RequestContactv3 from '../../../components/marketplace/Modal/RequestContactv3'

export default withRouteData(({ headData, company }) => (
    console.log(company),
    <Fragment>
        <Head>
            <title>{headData.pageTitle}</title>
            <meta property="og:title" content={headData.pageTitle} />
            <meta name="twitter:title" content={headData.pageTitle} />
            <meta name="description" content={headData.pageDescription} />
            <meta property="og:description" content={headData.pageDescription} />
            <meta name="twitter:description" content={headData.pageDescription} />
            <meta property="og:image" content={headData.ogImage} />
            <meta name="twitter:image" content={headData.ogImage} />
            <meta property="og:url" content={'https://mercos.com/integracao-erp'} />
        </Head>
        <MarketplacePartner company={company} />
    </Fragment>
))

class MarketplacePartner extends Component {
    constructor(props) {
        super(props)

    }
    setPartnerIdCookie(partnerId) {
        Cookies.set('leaderPartnerId', partnerId)
    }
    render() {
        var companyData = this.props.company.data,
            id = companyData.partner_id,
            title = companyData.title,
            logo = companyData.partner_logo,
            email = companyData.email || '',
            portifolioOwner = companyData.portifolio_owner

        console.log(companyData)
        return (
            <Fragment>
                {this.setPartnerIdCookie(id)}
                <Template representative marketplace>
                    <HeroPartners companyLogo={logo} stackedButtons title={<Fragment>Automatize seu processo comercial e acelere suas vendas</Fragment>} description={<Fragment>Use o força de vendas e e-commerce B2B Mercos integrado ao {title} e ganhe eficiência da entrada do pedido ao faturamento</Fragment>}
                        cta={<RequestContactv3
                            className='btn-partner-contact'
                            portifolioOwner={portifolioOwner}
                            partnerEmail={email}
                            partnerId={id}
                            partnerName={title}
                        />}
                    />


                    <section className="gray-bg">
                        <CenteredTitleSection title={<Fragment>A solução mais prática e completa do mercado para seu time de vendas</Fragment>} />
                        <NewOurResults hideErps />
                    </section>

                    <TwoCols sectionName="vendasOrganizadas" reverse />
                    <TwoCols sectionName="semErrosParceiros" />
                    <TwoCols sectionName="aplicativoPotencializa" reverse />
                    <TwoCols sectionName="vendaOnlineParceiros" />
                    <section>
                        <SliderTestimonialCardStars descriptionH4 title={`${SITE_CONSTANTS.CLIENTS_COUNT_WITH_PLUS} clientes melhoram a sua operação comercial com a Mercos.`} parceiros overtitleUsers />
                    </section>
                    <CardTrialNew horizontalCard modalSmall text={`Agende uma rápida demonstração do software Mercos para conhecer as funcionalidades e veja como é simples emitir e gerenciar pedidos, totalmente integrado ao seu ERP.`}
                        ctaBtn={<RequestContactv3
                            className='btn-partner-contact'
                            portifolioOwner={portifolioOwner}
                            partnerEmail={email}
                            partnerId={id}
                            partnerName={title} />} />
                </Template>

            </Fragment>
        )
    }
}



// WEBPACK FOOTER //
// /usr/src/site-blog/src/containers/site/NewPartner/NewPartnerv2.jsx